module.exports = __webpack_public_path__ + "static/tuhina-d0572acba1f71e2b54d27f4915c87675.jpg";